import React from 'react';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import classes from './UserDetails.module.css';


const UserDetails = props => {
    const ItemHeading = styled(Paper)(() => ({
        textAlign: 'center',
        boxShadow: "none",
        fontWeight: 700
    }));
    const Item = styled(Paper)(() => ({
        textAlign: 'center',
        boxShadow: "none"
    }));
    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={3}>
                    <ItemHeading>Oracle ID</ItemHeading>
                </Grid>
                <Grid item xs={3}>
                    <ItemHeading>First Name</ItemHeading>
                </Grid>
                <Grid item xs={3}>
                    <ItemHeading>Last Name</ItemHeading>
                </Grid>
                <Grid item xs={3}>
                    <ItemHeading># of Rosters</ItemHeading>
                </Grid>
            </Grid>
            <Grid className={classes.mtgrid} container spacing={2}>
                <Grid item xs={3}>
                    <Item>{props.data.oracleId}</Item>
                </Grid>
                <Grid item xs={3}>
                    <Item>{props.data.firstName}</Item>
                </Grid>
                <Grid item xs={3}>
                    <Item>{props.data.lastName}</Item>
                </Grid>
                <Grid item xs={3}>
                    <Item>{props.data.numberOfClassRosters}</Item>
                </Grid>
            </Grid>
        </div>

    )
}

export default UserDetails;